import { ProfileNav } from '../../component/nav/profile-nav'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PageContainer } from 'src/component/page-container/page-container'
import { ProfileAwardsScreen } from 'src/screen/profile/awards/profile-awards-screen'
import { ProfileConnectionsScreen } from 'src/screen/profile/connections/profile-connections-screen'
import { ProfileFavoritesScreen } from 'src/screen/profile/favorites/profile-favorites-screen'
import { ProfileOverviewScreen } from 'src/screen/profile/overview/profile-overview-screen'
import { ProfilePersonalInfoScreen } from 'src/screen/profile/personal-info/profile-personal-info-screen'
import { isFeatureFlagged } from 'src/util/feature-flags'

export const ProfileScreen = (): React.ReactElement => {
  return (
    <>
      <PageContainer>
        <ProfileNav />
      </PageContainer>
      <Routes>
        <Route path="personal" element={<ProfilePersonalInfoScreen />} />
        {/* Stripe redirects back to personal/success | personal/cancel after checkout. */}
        <Route path="personal/:checkoutStatus" element={<ProfilePersonalInfoScreen />} />
        <Route path="overview" element={<ProfileOverviewScreen />} />
        <Route path="awards" element={<ProfileAwardsScreen />} />
        <Route path="favorites" element={<ProfileFavoritesScreen />} />
        <Route
          path="connections"
          element={isFeatureFlagged('STRAVA') ? <Navigate to="/profile/personal" replace /> : <ProfileConnectionsScreen />}
        />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  )
}
